import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlainToolbarComponent } from './plain-toolbar/plain-toolbar.component';



@NgModule({
  declarations: [
    PlainToolbarComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [PlainToolbarComponent]
})
export class PlainToolbarModule { }
